import './App.css';
import { Routes, Route, BrowserRouter } from 'react-router-dom';
import AgendaAct from './components/activities/AgendaAct';
import Agenda from './components/agenda/Agenda';
import CitaForm from './components/agenda/CitaForm';
import ResetPass from './components/auth/ResetPass';
import Consentimiento from './components/consentimiento/Consentimiento';
import TutorForm from './components/consentimiento/TutorForm';
import Home from './components/home/Home';
import Navbar from './components/navbar/Navbar';
import HistoriaClinicaForm from './components/pacientes/paciente/HistoriaClinicaForm';
import Paciente from './components/pacientes/paciente/Paciente';
import PacienteForm from './components/pacientes/paciente/PacienteForm';
import Pacientes from './components/pacientes/Pacientes';
import Config from './components/config/Config';
import * as constantes from "./common/Constantes";
import CreatePassEmpleado from './components/auth/CreatePassEmpleado';
import Suscripcion from './components/config/Suscripcion';
import FacturacionWrapper from './components/facturacion/FacturacionWrapper';
import { PreferencesProvider } from './components/preferences/PreferencesProvider';
import { PreferencesDialog } from './components/preferences/PreferencesDialog';
import { PreferencesBanner } from './components/preferences/PreferencesBanner';
import { GoogleTag } from './components/preferences/GoogleTag';
import { MetaPixel } from './components/preferences/MetaPixel';
import WhatsApp from './components/config/WhatsApp';
import RegistroJornada from './components/jornada/RegistroJornada';
import stripePromise, { stripeElementsOptions } from './common/Stripe';
import { Elements } from '@stripe/react-stripe-js';
import VisorFacturaProvider from './components/facturacion/common/VisorFacturaProvider';
import ErrorBoundary, { ErrorBoundaryRuta } from './components/utilities/ErrorBoundary';

const App = () => {
  return (
    <BrowserRouter>
      {/* Último recurso: si falla algo fuera de las pantallas (menú, avisos), aviso en vez de pantalla en blanco */}
      <ErrorBoundary>
      <PreferencesProvider>
        <VisorFacturaProvider>
          <Navbar />
          <PreferencesBanner />
          <PreferencesDialog />
          <GoogleTag />
          <MetaPixel />
          {/* Si falla una pantalla, solo esa muestra el aviso: el menú sigue y al cambiar de pantalla se reinicia */}
          <ErrorBoundaryRuta>
          <Routes>
            <Route path={constantes.R_HOME} element={<Home />} />
            <Route path={constantes.R_PACIENTES} element={<Pacientes />} />
            <Route path={constantes.R_PACIENTE} element={<Paciente />} />
            <Route path={constantes.R_NUEVOPACIENTE} element={<PacienteForm />} />
            <Route path={constantes.R_FIRMARCI} element={<Consentimiento />} />
            <Route path={constantes.R_TUTORLEGAL} element={<TutorForm />} />
            <Route path={constantes.R_HISTORIACLINICA} element={<HistoriaClinicaForm />} />
            <Route path={constantes.R_AGENDA} element={<Agenda />} />
            <Route path={constantes.R_ACTIVIDADES} element={<AgendaAct />} />
            <Route path={constantes.R_CITA} element={<CitaForm />} />
            <Route path={constantes.R_RESETPASS} element={<ResetPass />} />
            <Route path={constantes.R_CONFIG} element={<Config />}/>
            <Route path={constantes.R_CREATEPASS} element={<CreatePassEmpleado />} />
            <Route path={constantes.R_FACTURACION} element={<FacturacionWrapper />} />
            <Route path={constantes.R_SUSCRIPCION} element={<Suscripcion />} />
            <Route path={constantes.R_JORNADA} element={<RegistroJornada />} />
            <Route 
              path={constantes.R_WHATSAPP} 
              element={
                <Elements stripe={stripePromise} options={stripeElementsOptions}>
                  <WhatsApp />
                </Elements>
              } 
            />
          </Routes>
          </ErrorBoundaryRuta>
        </VisorFacturaProvider>
      </PreferencesProvider>
      </ErrorBoundary>
    </BrowserRouter>
  );
}

export default App;
